import { render, staticRenderFns } from "./JaliscoChartBarComponent.vue?vue&type=template&id=345b9df7&scoped=true"
import script from "./JaliscoChartBarComponent.vue?vue&type=script&lang=js"
export * from "./JaliscoChartBarComponent.vue?vue&type=script&lang=js"
import style0 from "@/other/assets/css/app.css?vue&type=style&index=0&id=345b9df7&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345b9df7",
  null
  
)

export default component.exports